import { default as React, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import Cibil from "./Cibil/Cibil";
import IncomeDetails from "./IncomeDetails/IncomeDetails";
import PersonalInfo from "./PersonalInfo/PersonalInfo";
import PostSanctionedDocs from "./PostSanctionedDocs/PostSanctionedDocs";
import PreDisburseInfo from "./PreDisburse/PreDisburseInfo";
import Queries from "./Queries/Queries";
import CollectionDocs from "./CollectionDocs/CollectionDocs";

const LoanDetailsPendingView = (props) => {
  const productTypeParam = props.urlparams.params.producttype;
  const [activeKey, setActiveKey] = useState("personalinfo");
  const tabData = [
    { key: "personalinfo", name: "Personal Info" },
    { key: "incomedetails", name: "Income & BSA Info." },
    { key: "cibil", name: "CIBIL" },
    { key: "collectiondocs", name: "Documents" },
    { key: "queries", name: "Queries" },
    { key: "postsanctioneddocs", name: "Post Sanctioned Documents" },
    { key: "predisburse", name: "Pre-Disbursement" },
  ];

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  const changeTab = (e, key) => {
    setActiveKey(key);
    scrollToTop();
  };

  const getMainTitle = () => {
    let mainTitle = "Loan Details | Pending for Disbursement";
    return mainTitle;
  };

  const getBreadCums = () => {
    let pagetitle = props?.urlparams?.params?.name || "";
    return pagetitle;
  };

  return (
    <>
      <MainPagetitle
        mainTitle={getMainTitle()}
        back={getBreadCums()}
        backLink={`/app/loandetails?activetab=pending&producttype=${productTypeParam}`}
        pageTitle={"Loan Details"}
        parentTitle={"Home"}
        pageIcon={imagepaths.applicationCheckImg}
      />
      <div className="custom-tab-1 p-4">
        <Tab.Container
          defaultActiveKey={activeKey}
          activeKey={activeKey}
          onSelect={handleSelect}
        >
          <Nav as="ul" className="nav-tabs border-0">
            {tabData.map((data, i) => (
              <Nav.Item as="li" key={i}>
                <Nav.Link
                  eventKey={data.key}
                  className={Object.className({
                    "text-dark bg-transparent": true,
                    "pe-none": data.disabled === true ? true : false,
                  })}
                >
                  {data.name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <Tab.Content className="pt-4">
            {activeKey === "personalinfo" && (
              <Tab.Pane eventKey="personalinfo">
                <PersonalInfo changeTab={(...args) => changeTab(...args)} />
              </Tab.Pane>
            )}
            {activeKey === "incomedetails" && (
              <Tab.Pane eventKey="incomedetails">
                <IncomeDetails changeTab={(...args) => changeTab(...args)} />
              </Tab.Pane>
            )}
            {activeKey === "cibil" && (
              <Tab.Pane eventKey="cibil">
                <Cibil changeTab={(...args) => changeTab(...args)} />
              </Tab.Pane>
            )}
            {activeKey === "collectiondocs" && (
              <Tab.Pane eventKey="collectiondocs">
                <CollectionDocs changeTab={(...args) => changeTab(...args)} />
              </Tab.Pane>
            )}
            {activeKey === "queries" && (
              <Tab.Pane eventKey="queries">
                <Queries changeTab={(...args) => changeTab(...args)} />
              </Tab.Pane>
            )}
            {activeKey === "postsanctioneddocs" && (
              <Tab.Pane eventKey="postsanctioneddocs">
                <PostSanctionedDocs
                  changeTab={(...args) => changeTab(...args)}
                  handlePostSanction={(...args) => handlePostSanction(...args)}
                />
              </Tab.Pane>
            )}
            {activeKey === "predisburse" && (
              <Tab.Pane eventKey="predisburse">
                <PreDisburseInfo changeTab={(...args) => changeTab(...args)} />
              </Tab.Pane>
            )}
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
};

export default constore(LoanDetailsPendingView);
